// extracted by mini-css-extract-plugin
module.exports = {"PreviewWrapper":"preview_PreviewWrapper__1tGP_"};